// Shared by CRA and Node. Add one entry for every new route; see SEO_IMPLEMENTATION.md.
const site = {
  origin: 'https://www.checkstall.com',
  name: 'Checkstall Import',
  // Existing branded square logo; override per route with a real absolute image URL.
  socialImage: 'https://www.checkstall.com/logo512.png',
};
const routes = [
  {
    path: '/', indexable: true,
    title: 'Checkstall Import | Buy & Import Products from China',
    description: 'Buy directly from China with Checkstall Import. Source products from 1688 and Chinese suppliers, make supplier payments, inspect your goods and arrange shipping to Nigeria.',
  },
  {
    path: '/about', indexable: true,
    title: 'About Checkstall | Connecting Nigeria to Chinese Suppliers',
    description: 'Learn about Checkstall\'s mission, story and values, and how we connect Nigerian entrepreneurs with Chinese manufacturers through sourcing, payments and logistics.',
  },
  {
    path: '/people', indexable: true,
    title: 'Meet the Checkstall Team | China and Nigeria Operations',
    description: 'Meet the people behind Checkstall, from company leadership to China warehouse operations, working to support trade between China and Nigeria.',
  },
  {
    path: '/careers', indexable: true,
    title: 'Jobs and Careers at Checkstall | Join Our Team',
    description: 'Explore career opportunities at Checkstall, learn about our culture and benefits, and find roles supporting Nigerian entrepreneurs and international trade.',
  },
  {
    path: '/downloads', indexable: true,
    title: 'Download Checkstall Import App | Android & iPhone',
    description: 'Download the Checkstall Import app for Android or iPhone and start sourcing and ordering products directly from China.',
  },
  {
    path: '/contact', indexable: true,
    title: 'Contact Checkstall | Import Support and Enquiries',
    description: 'Contact the Checkstall team for help with sourcing and importing. Find our office details, send an enquiry and read answers to common customer questions.',
  },
  {
    path: '/privacy', indexable: true,
    title: 'Privacy Policy | Checkstall Import',
    description: 'Read how Checkstall collects, uses, shares and protects personal information, and learn about data retention, privacy rights and ways to contact us.',
  },
  {
    path: '/cookies', indexable: true,
    title: 'Cookie Policy | Checkstall Import',
    description: 'Learn how Checkstall uses cookies, local storage and similar technologies, which types we use, and how to manage your browser and device preferences.',
  },
  {
    path: '/refund', indexable: true,
    title: 'Refund Policy | Checkstall Import',
    description: 'Read Checkstall\'s refund policy, including eligibility, request timeframes, processing, return shipping, refund methods and how to seek help with a request.',
  },
  {
    path: '/terms', indexable: true,
    title: 'Terms of Service | Checkstall Import',
    description: 'Review the terms for using Checkstall\'s purchasing and transshipment services, including account responsibilities, service conditions and customer support.',
  },
  {
    path: '/how-it-works', indexable: true,
    title: 'How Checkstall Works | Import From China to Nigeria',
    description: 'Learn how to use Checkstall to source products from China, place orders, make supplier payments, inspect your goods and arrange shipping to Nigeria.',
  },
  {
    path: '/how-to-use', indexable: true,
    title: 'How to Use Checkstall | Product Search, Orders and Payment',
    description: 'Follow Checkstall\'s illustrated 10-step guide to search by keyword, image or 1688 link, review products, add items to your cart and complete your first order.',
  },
  {
    path: '/delete-data', indexable: false,
    title: 'Delete Your Account and Data | Checkstall',
    description: 'Find instructions for deleting your Checkstall account in the app or submit an account and personal data deletion request using our support form.',
    reason: 'Public account-management utility, not a search landing page.',
  },
  {
    path: '/reviews', indexable: true,
    title: 'Customer Reviews | Checkstall Import',
    description: 'Read customer reviews from Nigerian entrepreneurs and shoppers about their experiences using Checkstall.',
  },
  {
    path: '/start-importing', indexable: true,
    title: 'Start Importing from China | Checkstall',
    description: 'Start importing products from China to Nigeria with Checkstall. Source products, pay safely, and ship at affordable rates.',
    structuredData: true,
  },
];

// React Router's static paths are case-insensitive and accept a trailing slash.
function normalizePath(pathname) {
  return pathname.toLowerCase().replace(/\/+$/, '') || '/';
}
function resolveSeo(pathname) {
  const route = pathname == null ? undefined : routes.find((entry) => entry.path === normalizePath(pathname));
  const entry = route || {
    title: site.name,
    description: 'Source products from China and manage your imports with Checkstall.',
    indexable: false,
  };
  const canonical = route ? `${site.origin}${route.path}` : null;
  const ogImage = entry.ogImage === undefined ? site.socialImage : entry.ogImage;
  const twitterImage = entry.twitterImage === undefined ? ogImage : entry.twitterImage;
  return {
    ...entry, canonical,
    robots: entry.indexable ? 'index, follow' : 'noindex, follow',
    ogTitle: entry.ogTitle || entry.title,
    ogDescription: entry.ogDescription || entry.description,
    ogType: entry.ogType || 'website',
    ogImage, twitterImage,
    twitterTitle: entry.twitterTitle || entry.title,
    twitterDescription: entry.twitterDescription || entry.description,
    twitterCard: twitterImage ? (entry.twitterCard || 'summary') : 'summary',
    jsonLd: entry.structuredData ? {
      '@context': 'https://schema.org', '@type': 'WebPage',
      name: entry.title, description: entry.description, url: canonical,
      isPartOf: { '@type': 'WebSite', name: site.name, url: `${site.origin}/` },
    } : null,
  };
}
// Null means remove the tag, including images left by the previous route.
function metaTags(seo) {
  return [
    ['name', 'description', seo.description],
    ['name', 'robots', seo.robots],
    ['name', 'googlebot', seo.robots],
    ['property', 'og:title', seo.ogTitle],
    ['property', 'og:description', seo.ogDescription],
    ['property', 'og:url', seo.canonical],
    ['property', 'og:type', seo.ogType],
    ['property', 'og:site_name', site.name],
    ['property', 'og:image', seo.ogImage],
    ['name', 'twitter:card', seo.twitterCard],
    ['name', 'twitter:title', seo.twitterTitle],
    ['name', 'twitter:description', seo.twitterDescription],
    ['name', 'twitter:image', seo.twitterImage],
  ];
}
export { site, routes, normalizePath, resolveSeo, metaTags };
